/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_ad_unlock_desc = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Watch a short ad to unlock ${i?.feature} for this race. This resets each race week.`)
};

const es_f1_ad_unlock_desc = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mira un anuncio corto para desbloquear ${i?.feature} para esta carrera. Se reinicia cada semana de carrera.`)
};

const de_f1_ad_unlock_desc = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Schau eine kurze Werbung, um ${i?.feature} für dieses Rennen freizuschalten. Dies wird jede Rennwoche zurückgesetzt.`)
};

const nl_f1_ad_unlock_desc = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bekijk een korte advertentie om ${i?.feature} voor deze race te ontgrendelen. Dit wordt elke raceweek gereset.`)
};

const fr_f1_ad_unlock_desc = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Regardez une courte pub pour déverrouiller ${i?.feature} pour cette course. Cela se réinitialise chaque semaine de course.`)
};

const it_f1_ad_unlock_desc = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guarda una breve pubblicità per sbloccare ${i?.feature} per questa gara. Si resetta ogni settimana di gara.`)
};

const pt_br2_f1_ad_unlock_desc = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Assista a um anúncio curto para desbloquear ${i?.feature} para esta corrida. Isso reseta a cada semana de corrida.`)
};

const pt_f1_ad_unlock_desc = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Assista a um breve anúncio para desbloquear ${i?.feature} para esta corrida. Isto reinicia a cada semana de corrida.`)
};

const ja_f1_ad_unlock_desc = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`短い広告を見て${i?.feature}をこのレースでアンロック。毎レースウィークにリセットされます。`)
};

const zh_f1_ad_unlock_desc = /** @type {(inputs: { feature: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`观看一段短广告即可解锁本场比赛的${i?.feature}。每个比赛周重置。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ feature: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_ad_unlock_desc = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_ad_unlock_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_ad_unlock_desc", locale)
	if (locale === "en") return en_f1_ad_unlock_desc(inputs)
	if (locale === "es") return es_f1_ad_unlock_desc(inputs)
	if (locale === "de") return de_f1_ad_unlock_desc(inputs)
	if (locale === "nl") return nl_f1_ad_unlock_desc(inputs)
	if (locale === "fr") return fr_f1_ad_unlock_desc(inputs)
	if (locale === "it") return it_f1_ad_unlock_desc(inputs)
	if (locale === "pt-BR") return pt_br2_f1_ad_unlock_desc(inputs)
	if (locale === "pt") return pt_f1_ad_unlock_desc(inputs)
	if (locale === "ja") return ja_f1_ad_unlock_desc(inputs)
	return zh_f1_ad_unlock_desc(inputs)
};